import { Delete, Edit, TramSharp } from '@mui/icons-material'
import { IconButton } from '@mui/material'
import React, { useContext } from 'react'
import { TiposActivoContext } from '../../pages/catalogos/ActivosTipoPage';

export const TipoActivoComponent = ({tipoActivo}) => {
  const {modalAgregaTipoActivo, setModalAgregaTipoActivo, modalEliminaTipoActivo, setModalEliminaTipoActivo, obtenerTipos,tipoActivoSel, setTipoActivoSel} = useContext(TiposActivoContext);

  return (
    <div
      style={{
        display:'flex',
        flexDirection:'row',
        justifyContent:'space-between',
        marginTop:6,
        backgroundColor:'white',
        borderRadius:10,
        padding:5,
        alignItems:'center'
      }}
    >
      <div
        style={{
          fontSize:14,
          
        }}
      >
        {tipoActivo.TipoInstalacion}
      </div>
      <div>
          <IconButton
            onClick={() => {
              setModalAgregaTipoActivo(true);
              setTipoActivoSel(tipoActivo)
            }}
          >
            <Edit style={{color:'green'}} />
          </IconButton>
          <IconButton
            onClick={() => {
              setModalEliminaTipoActivo(true);
              setTipoActivoSel(tipoActivo)
            }}
          >
            <Delete style={{color:'red'}} />
          </IconButton>
        </div>
    </div>
  )
}
